import { AbInBevLogo, AllerganLogo, AnheuserBuschLogo, ApartmentListLogo, AppDynamicsLogo, AtlassianLogo, BettermentLogo, BetterMortgageLogo, BonobosLogo, BoxLogo, CampingWorldHomeLogo, ChimeLogo, ClassPassLogo, CleanChoiceEnergyLogo, ClearScoreLogo, CrossFitLogo, CryptoComLogo, DeliverooLogo, DigitalOceanLogo, DockerLogo, DominosLogo, DoordashLogo, DraftKingsLogo, DriftLogo, EarnestLogo, FenderLogo, FrameIoLogo, FoxLogo, FubotvLogo, GithubLogo, GlossierLogo, GoodeggsLogo, GoogleLogo, HotelTonightLogo, HousepartyLogo, HubspotLogo, IbmLogo, InstacartLogo, IntegraBeautyLogo, IntuitLogo, InvisionLogo, LendingTreeLogo, LevisLogo, LogMeInLogo, MeUndiesLogo, OptimizelyLogo, PeletonLogo, RugsComLogo, SchibstedLogo, SendGridLogo, ShopifyLogo, SpotHeroLogo, StaplesLogo, StaplesCanadaLogo, StylepitLogo, TaxfixLogo, TheMotleyFoolLogo, ToggleLogo, TradesyLogo, TrivagoLogo, UptvLogo, VacasaLogo, VistaLogo, VmwareLogo, WealthsimpleLogo, ZendeskLogo, RitualLogo, ShiftLogo, VeronicaBeardLogo, VeoLogo, OrchardLogo, BloomingdalesLogo, ConstellationResearchLogo, CvsHealthLogo, FaireLogo, FirstHorizonLogo, StanleySecurityLogo, SlackLogo, RokfinLogo, YCombinatorLogo, EventbriteLogo, AndreessenHorowitzLogo, ScoopLogo, ImperfectFoodsLogo, UberLogo, BookingLogo, YelpLogo, SpotifyLogo, AirbnbLogo, ZipRecruiterLogo, EtsyLogo, PepsiCoLogo, NextdoorLogo, GeneralMillsLogo, DswLogo, TheNewYorkTimesLogo, TelusDigitalLogo, AnthropologieLogo, TheSkimmLogo, RakutenLogo, SanofiLogo, CraftJackLogo, ReutersLogo, TeradataLogo, AngiLogo, AutodeskLogo, AvantLogo, CrunchyRollLogo, CsaaLogo, FrasersGroupLogo, ImaxLogo, MadeiraMadeiraLogo, BrightlineLogo, HatchLogo, LemonadeLogo, OutdoorsyLogo, RocketMoneyLogo, SwoopLogo, Talk360Logo, TawkifyLogo, ZolaLogo, PagerDutyLogo, MindbodygreenLogo, BabylistLogo, FidelityLogo, GoogleCloudLogo, ZenjobLogo, TwilioLogo, TwilioSegmentLogo, TredenceLogo, PepperStoneLogo } from '@segment/matcha/components/CompanyLogos/Company';
import { AbInBevMonoLogo, AllerganMonoLogo, AnheuserBuschMonoLogo, ApartmentListMonoLogo, AppDynamicsMonoLogo, AtlassianMonoLogo, BettermentMonoLogo, BetterMortgageMonoLogo, BonobosMonoLogo, BoxMonoLogo, ChimeMonoLogo, ClassPassMonoLogo, CleanChoiceEnergyMonoLogo, ClearScoreMonoLogo, CryptoComMonoLogo, DeliverooMonoLogo, DigitalOceanMonoLogo, DockerMonoLogo, DominosMonoLogo, DoordashMonoLogo, DraftKingsMonoLogo, DriftMonoLogo, EarnestMonoLogo, FenderMonoLogo, FoxMonoLogo, FuboTvMonoLogo, GithubMonoLogo, GlossierMonoLogo, GoodeggsMonoLogo, GoogleMonoLogo, HotelTonightMonoLogo, HousepartyMonoLogo, HubspotMonoLogo, IbmMonoLogo, InstacartMonoLogo, IntegraBeautyMonoLogo, IntuitMonoLogo, InvisionMonoLogo, LendingTreeMonoLogo, LevisMonoLogo, LogMeInMonoLogo, MeUndiesMonoLogo, OptimizelyMonoLogo, PeletonMonoLogo, RugsComMonoLogo, SchibstedMonoLogo, SendGridMonoLogo, ShopifyMonoLogo, SpotHeroMonoLogo, StaplesMonoLogo, StaplesCanadaMonoLogo, StylepitMonoLogo, TaxfixMonoLogo, TheMotleyFoolMonoLogo, ToggleMonoLogo, TradesyMonoLogo, TrivagoMonoLogo, UptvMonoLogo, VacasaMonoLogo, VistaMonoLogo, VmwareMonoLogo, WealthsimpleMonoLogo, ZendeskMonoLogo, RitualMonoLogo, ShiftMonoLogo, VeronicaBeardMonoLogo, VeoMonoLogo, OrchardMonoLogo, BloomingdalesMonoLogo, ConstellationResearchMonoLogo, CvsHealthMonoLogo, FaireMonoLogo, FirstHorizonMonoLogo, StanleySecurityMonoLogo, SlackMonoLogo, RokfinMonoLogo, YCombinatorMonoLogo, EventbriteMonoLogo, AndreessenHorowitzMonoLogo, ScoopMonoLogo, ImperfectFoodsMonoLogo, PepsiCoMonoLogo, NextdoorMonoLogo, GeneralMillsMonoLogo, DswMonoLogo, TheNewYorkTimesMonoLogo, TelusDigitalMonoLogo, AnthropologieMonoLogo, TheSkimmMonoLogo, RakutenMonoLogo, SanofiMonoLogo, CraftJackMonoLogo, ReutersMonoLogo, TeradataMonoLogo, CampingWorldHomeMonoLogo, CrossFitMonoLogo, FrameIoMonoLogo, AngiMonoLogo, AutodeskMonoLogo, AvantMonoLogo, CrunchyRollMonoLogo, CsaaMonoLogo, FrasersGroupMonoLogo, ImaxMonoLogo, MadeiraMadeiraMonoLogo, BrightlineMonoLogo, HatchMonoLogo, LemonadeMonoLogo, OutdoorsyMonoLogo, RocketMoneyMonoLogo, SwoopMonoLogo, Talk360MonoLogo, TawkifyMonoLogo, ZolaMonoLogo, PagerDutyMonoLogo, BabylistMonoLogo, MindbodygreenMonoLogo, FidelityMonoLogo, GoogleCloudMonoLogo, ZenjobMonoLogo, TwilioMonoLogo, TwilioSegmentMonoLogo, TredenceMonoLogo, PepperStoneMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono';
export var carouselLogosMono = {
  RAKUTEN: {
    id: "rakuten",
    width: 89,
    height: 26,
    icon: RakutenMonoLogo
  },
  DIGITAL_OCEAN: {
    id: "digital-ocean",
    width: 178,
    height: 33,
    icon: DigitalOceanMonoLogo
  },
  IBM: {
    id: "ibm",
    width: 70,
    height: 32,
    icon: IbmMonoLogo
  },
  DOMINOS: {
    id: "dominos",
    width: 145,
    height: 32,
    icon: DominosMonoLogo
  },
  ANHEUSER_BUSCH: {
    id: "anheuser-busch",
    width: 436,
    height: 32,
    icon: AnheuserBuschMonoLogo
  },
  VMWARE: {
    id: "vmware",
    width: 148,
    height: 23,
    icon: VmwareMonoLogo
  },
  LEVIS: {
    id: "levis",
    width: 65,
    height: 32,
    icon: LevisMonoLogo
  },
  LOG_ME_IN: {
    id: "log-me-in",
    width: 99,
    height: 33,
    icon: LogMeInMonoLogo
  },
  CLEAR_SCORE: {
    id: "clear-score",
    width: 157,
    height: 22,
    icon: ClearScoreMonoLogo
  },
  VACASA: {
    id: "vacasa",
    width: 187,
    height: 37,
    icon: VacasaMonoLogo
  },
  STAPLES: {
    id: "staples",
    width: 172,
    height: 32,
    icon: StaplesMonoLogo
  },
  STAPLES_CANADA: {
    id: "staples-canada",
    width: 158,
    height: 32,
    icon: StaplesCanadaMonoLogo
  },
  INTUIT: {
    id: "intuit",
    width: 83,
    height: 32,
    icon: IntuitMonoLogo
  },
  THE_SKIMM: {
    id: "the-skimm",
    width: 64,
    height: 33,
    icon: TheSkimmMonoLogo
  },
  DRIFT: {
    id: "drift",
    width: 92,
    height: 33,
    icon: DriftMonoLogo
  },
  ALLERGAN: {
    id: "allergan",
    width: 144,
    height: 32,
    icon: AllerganMonoLogo
  },
  GLOSSIER: {
    id: "glossier",
    width: 91,
    height: 33,
    icon: GlossierMonoLogo
  },
  AB_IN_BEV: {
    id: "ab-in-bev",
    width: 176,
    height: 32,
    icon: AbInBevMonoLogo
  },
  SEND_GRID: {
    id: "send-grid",
    width: 126,
    height: 33,
    icon: SendGridMonoLogo
  },
  ZENDESK: {
    id: "zendesk",
    width: 130,
    height: 28,
    icon: ZendeskMonoLogo
  },
  OPTIMIZELY: {
    id: "optimizely",
    width: 126,
    height: 32,
    icon: OptimizelyMonoLogo
  },
  DOCKER: {
    id: "docker",
    width: 125,
    height: 32,
    icon: DockerMonoLogo
  },
  INVISION: {
    id: "invision",
    width: 87,
    height: 33,
    icon: InvisionMonoLogo
  },
  ATLASSIAN: {
    id: "atlassian",
    width: 168,
    height: 33,
    icon: AtlassianMonoLogo
  },
  FOX: {
    id: "fox",
    width: 76,
    height: 32,
    icon: FoxMonoLogo
  },
  GOOGLE: {
    id: "google",
    width: 95,
    height: 32,
    icon: GoogleMonoLogo
  },
  BONOBOS: {
    id: "bonobos",
    width: 136,
    height: 33,
    icon: BonobosMonoLogo
  },
  THE_MOTLEY_FOOL: {
    id: "the-motley-fool",
    width: 118,
    height: 32,
    icon: TheMotleyFoolMonoLogo
  },
  CRYPTO_COM: {
    id: "crypto-com",
    width: 167,
    height: 33,
    icon: CryptoComMonoLogo
  },
  WEALTHSIMPLE: {
    id: "wealthsimple",
    width: 162,
    height: 32,
    icon: WealthsimpleMonoLogo
  },
  CHIME: {
    id: "chime",
    width: 112,
    height: 32,
    icon: ChimeMonoLogo
  },
  EARNEST: {
    id: "earnest",
    width: 118,
    height: 32,
    icon: EarnestMonoLogo
  },
  BETTER_MORTGAGE: {
    id: "better-mortgage",
    width: 92,
    height: 32,
    icon: BetterMortgageMonoLogo
  },
  TAXFIX: {
    id: "taxfix",
    width: 87,
    height: 32,
    icon: TaxfixMonoLogo
  },
  INSTACART: {
    id: "instacart",
    width: 160,
    height: 32,
    icon: InstacartMonoLogo
  },
  APARTMENT_LIST: {
    id: "apartment-list",
    width: 186,
    height: 33,
    icon: ApartmentListMonoLogo
  },
  DOORDASH: {
    id: "doordash",
    width: 172,
    height: 33,
    icon: DoordashMonoLogo
  },
  DELIVEROO: {
    id: "deliveroo",
    width: 120,
    height: 32,
    icon: DeliverooMonoLogo
  },
  LENDING_TREE: {
    id: "lending-tree",
    width: 106,
    height: 32,
    icon: LendingTreeMonoLogo
  },
  HOTEL_TONIGHT: {
    id: "hotel-tonight",
    width: 157,
    height: 33,
    icon: HotelTonightMonoLogo
  },
  UPTV: {
    id: "uptv",
    width: 52,
    height: 32,
    icon: UptvMonoLogo
  },
  SCHIBSTED: {
    id: "schibsted",
    width: 126,
    height: 33,
    icon: SchibstedMonoLogo
  },
  FUBOTV: {
    id: "fubotv",
    width: 74,
    height: 33,
    icon: FuboTvMonoLogo
  },
  BETTERMENT: {
    id: "betterment",
    width: 244,
    height: 32,
    icon: BettermentMonoLogo
  },
  DRAFT_KINGS: {
    id: "draft-kings",
    width: 95,
    height: 48,
    icon: DraftKingsMonoLogo
  },
  HOUSEPARTY: {
    id: "houseparty",
    width: 158,
    height: 33,
    icon: HousepartyMonoLogo
  },
  SPOT_HERO: {
    id: "spot-hero",
    width: 52,
    height: 32,
    icon: SpotHeroMonoLogo
  },
  CLASS_PASS: {
    id: "class-pass",
    width: 214,
    height: 32,
    icon: ClassPassMonoLogo
  },
  STYLEPIT: {
    id: "stylepit",
    width: 105,
    height: 33,
    icon: StylepitMonoLogo
  },
  PELETON: {
    id: "peleton",
    width: 109,
    height: 32,
    icon: PeletonMonoLogo
  },
  RUGS: {
    id: "rugs",
    width: 105,
    height: 33,
    icon: RugsComMonoLogo
  },
  TRADESY: {
    id: "tradesy",
    width: 166,
    height: 33,
    icon: TradesyMonoLogo
  },
  ME_UNDIES: {
    id: "me-undies",
    width: 119,
    height: 33,
    icon: MeUndiesMonoLogo
  },
  FENDER: {
    id: "fender",
    width: 86,
    height: 32,
    icon: FenderMonoLogo
  },
  TRIVAGO: {
    id: "trivago",
    width: 107,
    height: 32,
    icon: TrivagoMonoLogo
  },
  TOGGLE: {
    id: "toggle",
    width: 123,
    height: 32,
    icon: ToggleMonoLogo
  },
  GOOD_EGGS: {
    id: "good-eggs",
    width: 52,
    height: 33,
    icon: GoodeggsMonoLogo
  },
  APP_DYNAMICS: {
    id: "app-dynamics",
    width: 200,
    height: 32,
    icon: AppDynamicsMonoLogo
  },
  INTEGRA_BEAUTY: {
    id: "integra-beauty",
    width: 61,
    height: 32,
    icon: IntegraBeautyMonoLogo
  },
  CLEAN_CHOICE_ENERGY: {
    id: "clean-choice-energy",
    width: 87,
    height: 33,
    icon: CleanChoiceEnergyMonoLogo
  },
  VISTA: {
    id: "vista",
    width: 87,
    height: 32,
    icon: VistaMonoLogo
  },
  RITUAL: {
    id: "ritual",
    width: 64,
    height: 32,
    icon: RitualMonoLogo
  },
  SHIFT: {
    id: "shift",
    width: 80,
    height: 32,
    icon: ShiftMonoLogo
  },
  VERONICA_BEARD: {
    id: "veronica-beard",
    width: 265,
    height: 32,
    icon: VeronicaBeardMonoLogo
  },
  VEO: {
    id: "veo",
    width: 63,
    height: 32,
    icon: VeoMonoLogo
  },
  ORCHARD: {
    id: "orchard",
    width: 103,
    height: 32,
    icon: OrchardMonoLogo
  },
  STANLEY_SECURITY: {
    id: "stanley-security",
    width: 106,
    height: 33,
    icon: StanleySecurityMonoLogo
  },
  FIRST_HORIZON: {
    id: "first-horizon",
    width: 114,
    height: 32,
    icon: FirstHorizonMonoLogo
  },
  FAIRE: {
    id: "faire",
    width: 145,
    height: 33,
    icon: FaireMonoLogo
  },
  CVS_HEALTH: {
    id: "cvs-health",
    width: 191,
    height: 33,
    icon: CvsHealthMonoLogo
  },
  BLOOMINGDALES: {
    id: "bloomingdales",
    width: 158,
    height: 32,
    icon: BloomingdalesMonoLogo
  },
  CONSTELLATION_RESEARCH: {
    id: "constellation-research",
    width: 146,
    height: 33,
    icon: ConstellationResearchMonoLogo
  },
  ROKFIN: {
    id: "rokfin",
    width: 74,
    height: 24,
    icon: RokfinMonoLogo
  },
  SLACK: {
    id: "slack",
    width: 108,
    height: 32,
    icon: SlackMonoLogo
  },
  Y_COMBINATOR: {
    id: "y-combinator",
    width: 142,
    height: 31,
    icon: YCombinatorMonoLogo
  },
  EVENTBRITE: {
    id: "eventbrite",
    width: 153,
    height: 28,
    icon: EventbriteMonoLogo
  },
  ANDREESSEN_HOROWITZ: {
    id: "andreesen-horowitz",
    width: 139,
    height: 32,
    icon: AndreessenHorowitzMonoLogo
  },
  SCOOP: {
    id: "scoop",
    width: 96,
    height: 32,
    icon: ScoopMonoLogo
  },
  IMPERFECT_FOODS: {
    id: "imperfect-foods",
    width: 77,
    height: 32,
    icon: ImperfectFoodsMonoLogo
  },
  UBER: {
    id: "uber",
    width: 70,
    height: 32,
    icon: UberLogo
  },
  BOOKING: {
    id: "booking",
    width: 169,
    height: 32,
    icon: BookingLogo
  },
  YELP: {
    id: "yelp",
    width: 86,
    height: 32,
    icon: YelpLogo
  },
  SPOTIFY: {
    id: "spotify",
    width: 104,
    height: 32,
    icon: SpotifyLogo
  },
  AIRBNB: {
    id: "airbnb",
    width: 104,
    height: 32,
    icon: AirbnbLogo
  },
  ZIPRECRUITER: {
    id: "ziprecruiter",
    width: 143,
    height: 32,
    icon: ZipRecruiterLogo
  },
  ETSY: {
    id: "etsy",
    width: 60,
    height: 32,
    icon: EtsyLogo
  },
  BOX: {
    id: "box",
    width: 60,
    height: 32,
    icon: BoxMonoLogo
  },
  PEPSICO: {
    id: "pepsico",
    width: 138,
    height: 32,
    icon: PepsiCoMonoLogo
  },
  NEXTDOOR: {
    id: "nextdoor",
    width: 120,
    height: 32,
    icon: NextdoorMonoLogo
  },
  GENERALMILLS: {
    id: "generalmills",
    width: 54,
    height: 33,
    icon: GeneralMillsMonoLogo
  },
  DSW: {
    id: "dsw",
    width: 118,
    height: 33,
    icon: DswMonoLogo
  },
  THENEWYORKTIMES: {
    id: "thenewyorktimes",
    width: 140,
    height: 32,
    icon: TheNewYorkTimesMonoLogo
  },
  TELUSDIGITAL: {
    id: "telusdigital",
    width: 140,
    height: 32,
    icon: TelusDigitalMonoLogo
  },
  ANTHROPOLOGIE: {
    id: "anthropologie",
    width: 140,
    height: 32,
    icon: AnthropologieMonoLogo
  },
  SHOPIFY: {
    id: "shopify",
    width: 110,
    height: 32,
    icon: ShopifyMonoLogo
  },
  HUBSPOT: {
    id: "hubspot",
    width: 97,
    height: 33,
    icon: HubspotMonoLogo
  },
  GITHUB: {
    id: "github",
    width: 119,
    height: 32,
    icon: GithubMonoLogo
  },
  SANOFI: {
    id: "sanofi",
    width: 122,
    height: 32,
    icon: SanofiMonoLogo
  },
  CRAFTJACK: {
    id: "craftjack",
    width: 113,
    height: 33,
    icon: CraftJackMonoLogo
  },
  REUTERS: {
    id: "reuters",
    width: 141,
    height: 32,
    icon: ReutersMonoLogo
  },
  TERADATA: {
    id: "teradata",
    width: 153,
    height: 30,
    icon: TeradataMonoLogo
  },
  CAMPING_WORLD: {
    id: "camping-world",
    width: 203,
    height: 32,
    icon: CampingWorldHomeMonoLogo
  },
  CROSS_FIT: {
    id: "cross-fit",
    width: 100,
    height: 32,
    icon: CrossFitMonoLogo
  },
  FRAME_IO: {
    id: "frame-io",
    width: 129,
    height: 33,
    icon: FrameIoMonoLogo
  },
  ANGI: {
    id: "angi",
    width: 53,
    height: 32,
    icon: AngiMonoLogo
  },
  AUTODESK: {
    id: "autodesk",
    width: 312,
    height: 32,
    icon: AutodeskMonoLogo
  },
  AVANT: {
    id: "avant",
    width: 230,
    height: 32,
    icon: AvantMonoLogo
  },
  CRUNCHY_ROLL: {
    id: "crunchy-roll",
    width: 169,
    height: 32,
    icon: CrunchyRollMonoLogo
  },
  CSAA: {
    id: "csaa-logo",
    width: 171,
    height: 32,
    icon: CsaaMonoLogo
  },
  FRASERS_GROUP: {
    id: "frasers-group",
    width: 253,
    height: 32,
    icon: FrasersGroupMonoLogo
  },
  IMAX: {
    id: "imax",
    width: 169,
    height: 32,
    icon: ImaxMonoLogo
  },
  MADEIRA_MADEIRA: {
    id: "madeira-madeira",
    width: 228,
    height: 32,
    icon: MadeiraMadeiraMonoLogo
  },
  BRIGHTLINE: {
    id: "brightline",
    width: 131,
    height: 32,
    icon: BrightlineMonoLogo
  },
  HATCH: {
    id: "hatch",
    width: 159,
    height: 32,
    icon: HatchMonoLogo
  },
  LEMONADE: {
    id: "lemonade",
    width: 141,
    height: 32,
    icon: LemonadeMonoLogo
  },
  OUTDOORSY: {
    id: "outdoorsy",
    width: 142,
    height: 32,
    icon: OutdoorsyMonoLogo
  },
  ROCKET_MONEY: {
    id: "rocket-money",
    width: 144,
    height: 32,
    icon: RocketMoneyMonoLogo
  },
  SWOOP: {
    id: "swoop",
    width: 93,
    height: 32,
    icon: SwoopMonoLogo
  },
  TALK360: {
    id: "talk360",
    width: 170,
    height: 32,
    icon: Talk360MonoLogo
  },
  TAWKIFY: {
    id: "tawkify",
    width: 129,
    height: 32,
    icon: TawkifyMonoLogo
  },
  ZOLA: {
    id: "zola",
    width: 209,
    height: 32,
    icon: ZolaMonoLogo
  },
  PAGER_DUTY: {
    id: "pager-duty",
    width: 118,
    height: 32,
    icon: PagerDutyMonoLogo
  },
  MIND_BODY_GREEN: {
    id: "pager-duty",
    width: 187,
    height: 32,
    icon: MindbodygreenMonoLogo
  },
  BABYLIST: {
    id: "babylist",
    width: 146,
    height: 32,
    icon: BabylistMonoLogo
  },
  FIDELITY: {
    id: "fidelity",
    width: 119,
    height: 32,
    icon: FidelityMonoLogo
  },
  GOOGLE_CLOUD: {
    id: "google-cloud",
    width: 185,
    height: 32,
    icon: GoogleCloudMonoLogo
  },
  ZENJOB: {
    id: "zenjob",
    width: 171,
    height: 32,
    icon: ZenjobMonoLogo
  },
  TWILIO: {
    id: "twilio",
    width: 104,
    height: 32,
    icon: TwilioMonoLogo
  },
  TWILIO_SEGMENT: {
    id: "twilio-segment",
    width: 116,
    height: 32,
    icon: TwilioSegmentMonoLogo
  },
  TREDENCE: {
    id: "tredence",
    width: 152,
    height: 32,
    icon: TredenceMonoLogo
  },
  PEPPER_STONE: {
    id: "pepper-stone",
    width: 163,
    height: 32,
    icon: PepperStoneMonoLogo
  }
};
export var carouselLogos = {
  RAKUTEN: {
    id: "rakuten",
    width: 89,
    height: 26,
    icon: RakutenLogo
  },
  DIGITAL_OCEAN: {
    id: "digital-ocean",
    width: 178,
    height: 33,
    icon: DigitalOceanLogo
  },
  IBM: {
    id: "ibm",
    width: 70,
    height: 32,
    icon: IbmLogo
  },
  DOMINOS: {
    id: "dominos",
    width: 145,
    height: 32,
    icon: DominosLogo
  },
  ANHEUSER_BUSCH: {
    id: "anheuser-busch",
    width: 436,
    height: 32,
    icon: AnheuserBuschLogo
  },
  VMWARE: {
    id: "vmware",
    width: 148,
    height: 23,
    icon: VmwareLogo
  },
  LEVIS: {
    id: "levis",
    width: 65,
    height: 32,
    icon: LevisLogo
  },
  LOG_ME_IN: {
    id: "log-me-in",
    width: 99,
    height: 33,
    icon: LogMeInLogo
  },
  CLEAR_SCORE: {
    id: "clear-score",
    width: 157,
    height: 22,
    icon: ClearScoreLogo
  },
  VACASA: {
    id: "vacasa",
    width: 187,
    height: 37,
    icon: VacasaLogo
  },
  STAPLES: {
    id: "staples",
    width: 172,
    height: 32,
    icon: StaplesLogo
  },
  STAPLES_CANADA: {
    id: "staples-canada",
    width: 158,
    height: 32,
    icon: StaplesCanadaLogo
  },
  INTUIT: {
    id: "intuit",
    width: 83,
    height: 32,
    icon: IntuitLogo
  },
  THE_SKIMM: {
    id: "the-skimm",
    width: 64,
    height: 33,
    icon: TheSkimmLogo
  },
  DRIFT: {
    id: "drift",
    width: 92,
    height: 33,
    icon: DriftLogo
  },
  ALLERGAN: {
    id: "allergan",
    width: 144,
    height: 32,
    icon: AllerganLogo
  },
  GLOSSIER: {
    id: "glossier",
    width: 91,
    height: 33,
    icon: GlossierLogo
  },
  AB_IN_BEV: {
    id: "ab-in-bev",
    width: 176,
    height: 32,
    icon: AbInBevLogo
  },
  SEND_GRID: {
    id: "send-grid",
    width: 126,
    height: 33,
    icon: SendGridLogo
  },
  ZENDESK: {
    id: "zendesk",
    width: 130,
    height: 28,
    icon: ZendeskLogo
  },
  OPTIMIZELY: {
    id: "optimizely",
    width: 126,
    height: 32,
    icon: OptimizelyLogo
  },
  DOCKER: {
    id: "docker",
    width: 125,
    height: 32,
    icon: DockerLogo
  },
  INVISION: {
    id: "invision",
    width: 87,
    height: 33,
    icon: InvisionLogo
  },
  ATLASSIAN: {
    id: "atlassian",
    width: 168,
    height: 33,
    icon: AtlassianLogo
  },
  FOX: {
    id: "fox",
    width: 76,
    height: 32,
    icon: FoxLogo
  },
  GOOGLE: {
    id: "google",
    width: 95,
    height: 32,
    icon: GoogleLogo
  },
  BONOBOS: {
    id: "bonobos",
    width: 136,
    height: 33,
    icon: BonobosLogo
  },
  THE_MOTLEY_FOOL: {
    id: "the-motley-fool",
    width: 118,
    height: 32,
    icon: TheMotleyFoolLogo
  },
  CRYPTO_COM: {
    id: "crypto-com",
    width: 167,
    height: 33,
    icon: CryptoComLogo
  },
  WEALTHSIMPLE: {
    id: "wealthsimple",
    width: 162,
    height: 32,
    icon: WealthsimpleLogo
  },
  CHIME: {
    id: "chime",
    width: 112,
    height: 32,
    icon: ChimeLogo
  },
  EARNEST: {
    id: "earnest",
    width: 118,
    height: 32,
    icon: EarnestLogo
  },
  BETTER_MORTGAGE: {
    id: "better-mortgage",
    width: 92,
    height: 32,
    icon: BetterMortgageLogo
  },
  TAXFIX: {
    id: "taxfix",
    width: 87,
    height: 32,
    icon: TaxfixLogo
  },
  INSTACART: {
    id: "instacart",
    width: 160,
    height: 32,
    icon: InstacartLogo
  },
  APARTMENT_LIST: {
    id: "apartment-list",
    width: 186,
    height: 33,
    icon: ApartmentListLogo
  },
  DOORDASH: {
    id: "doordash",
    width: 172,
    height: 33,
    icon: DoordashLogo
  },
  DELIVEROO: {
    id: "deliveroo",
    width: 120,
    height: 32,
    icon: DeliverooLogo
  },
  LENDING_TREE: {
    id: "lending-tree",
    width: 106,
    height: 32,
    icon: LendingTreeLogo
  },
  HOTEL_TONIGHT: {
    id: "hotel-tonight",
    width: 157,
    height: 33,
    icon: HotelTonightLogo
  },
  UPTV: {
    id: "uptv",
    width: 52,
    height: 32,
    icon: UptvLogo
  },
  SCHIBSTED: {
    id: "schibsted",
    width: 126,
    height: 33,
    icon: SchibstedLogo
  },
  FUBOTV: {
    id: "fubotv",
    width: 74,
    height: 33,
    icon: FubotvLogo
  },
  BETTERMENT: {
    id: "betterment",
    width: 244,
    height: 32,
    icon: BettermentLogo
  },
  DRAFT_KINGS: {
    id: "draft-kings",
    width: 95,
    height: 48,
    icon: DraftKingsLogo
  },
  HOUSEPARTY: {
    id: "houseparty",
    width: 158,
    height: 33,
    icon: HousepartyLogo
  },
  SPOT_HERO: {
    id: "spot-hero",
    width: 52,
    height: 32,
    icon: SpotHeroLogo
  },
  CLASS_PASS: {
    id: "class-pass",
    width: 214,
    height: 32,
    icon: ClassPassLogo
  },
  STYLEPIT: {
    id: "stylepit",
    width: 105,
    height: 33,
    icon: StylepitLogo
  },
  PELETON: {
    id: "peleton",
    width: 109,
    height: 32,
    icon: PeletonLogo
  },
  RUGS: {
    id: "rugs",
    width: 105,
    height: 33,
    icon: RugsComLogo
  },
  TRADESY: {
    id: "tradesy",
    width: 166,
    height: 33,
    icon: TradesyLogo
  },
  ME_UNDIES: {
    id: "me-undies",
    width: 119,
    height: 33,
    icon: MeUndiesLogo
  },
  FENDER: {
    id: "fender",
    width: 86,
    height: 32,
    icon: FenderLogo
  },
  TRIVAGO: {
    id: "trivago",
    width: 107,
    height: 32,
    icon: TrivagoLogo
  },
  TOGGLE: {
    id: "toggle",
    width: 123,
    height: 32,
    icon: ToggleLogo
  },
  GOOD_EGGS: {
    id: "good-eggs",
    width: 52,
    height: 33,
    icon: GoodeggsLogo
  },
  APP_DYNAMICS: {
    id: "app-dynamics",
    width: 200,
    height: 32,
    icon: AppDynamicsLogo
  },
  INTEGRA_BEAUTY: {
    id: "integra-beauty",
    width: 61,
    height: 32,
    icon: IntegraBeautyLogo
  },
  CLEAN_CHOICE_ENERGY: {
    id: "clean-choice-energy",
    width: 87,
    height: 33,
    icon: CleanChoiceEnergyLogo
  },
  VISTA: {
    id: "vista",
    width: 87,
    height: 32,
    icon: VistaLogo
  },
  RITUAL: {
    id: "ritual",
    width: 64,
    height: 32,
    icon: RitualLogo
  },
  SHIFT: {
    id: "shift",
    width: 80,
    height: 32,
    icon: ShiftLogo
  },
  VERONICA_BEARD: {
    id: "veronica-beard",
    width: 265,
    height: 32,
    icon: VeronicaBeardLogo
  },
  VEO: {
    id: "veo",
    width: 63,
    height: 32,
    icon: VeoLogo
  },
  ORCHARD: {
    id: "orchard",
    width: 103,
    height: 32,
    icon: OrchardLogo
  },
  STANLEY_SECURITY: {
    id: "stanley-security",
    width: 107,
    height: 32,
    icon: StanleySecurityLogo
  },
  FIRST_HORIZON: {
    id: "first-horizon",
    width: 114,
    height: 33,
    icon: FirstHorizonLogo
  },
  FAIRE: {
    id: "faire",
    width: 145,
    height: 32,
    icon: FaireLogo
  },
  CVS_HEALTH: {
    id: "cvs-health",
    width: 191,
    height: 32,
    icon: CvsHealthLogo
  },
  BLOOMINGDALES: {
    id: "bloomingdales",
    width: 158,
    height: 32,
    icon: BloomingdalesLogo
  },
  CONSTELLATION_RESEARCH: {
    id: "constellation-research",
    width: 146,
    height: 33,
    icon: ConstellationResearchLogo
  },
  ROKFIN: {
    id: "rokfin",
    width: 74,
    height: 24,
    icon: RokfinLogo
  },
  SLACK: {
    id: "slack",
    width: 108,
    height: 32,
    icon: SlackLogo
  },
  Y_COMBINATOR: {
    id: "y-combinator",
    width: 142,
    height: 31,
    icon: YCombinatorLogo
  },
  EVENTBRITE: {
    id: "eventbrite",
    width: 153,
    height: 28,
    icon: EventbriteLogo
  },
  ANDREESSEN_HOROWITZ: {
    id: "andreesen-horowitz",
    width: 139,
    height: 32,
    icon: AndreessenHorowitzLogo
  },
  SCOOP: {
    id: "scoop",
    width: 96,
    height: 32,
    icon: ScoopLogo
  },
  IMPERFECT_FOODS: {
    id: "imperfect-foods",
    width: 77,
    height: 32,
    icon: ImperfectFoodsLogo
  },
  UBER: {
    id: "uber",
    width: 70,
    height: 32,
    icon: UberLogo
  },
  BOOKING: {
    id: "booking",
    width: 169,
    height: 32,
    icon: BookingLogo
  },
  YELP: {
    id: "yelp",
    width: 86,
    height: 32,
    icon: YelpLogo
  },
  SPOTIFY: {
    id: "spotify",
    width: 104,
    height: 32,
    icon: SpotifyLogo
  },
  AIRBNB: {
    id: "airbnb",
    width: 104,
    height: 32,
    icon: AirbnbLogo
  },
  ZIPRECRUITER: {
    id: "ziprecruiter",
    width: 143,
    height: 32,
    icon: ZipRecruiterLogo
  },
  ETSY: {
    id: "etsy",
    width: 60,
    height: 32,
    icon: EtsyLogo
  },
  BOX: {
    id: "box",
    width: 60,
    height: 32,
    icon: BoxLogo
  },
  PEPSICO: {
    id: "pepsico",
    width: 138,
    height: 32,
    icon: PepsiCoLogo
  },
  NEXTDOOR: {
    id: "nextdoor",
    width: 120,
    height: 32,
    icon: NextdoorLogo
  },
  GENERALMILLS: {
    id: "generalmills",
    width: 54,
    height: 33,
    icon: GeneralMillsLogo
  },
  DSW: {
    id: "dsw",
    width: 118,
    height: 33,
    icon: DswLogo
  },
  THENEWYORKTIMES: {
    id: "thenewyorktimes",
    width: 140,
    height: 32,
    icon: TheNewYorkTimesLogo
  },
  TELUSDIGITAL: {
    id: "telusdigital",
    width: 140,
    height: 32,
    icon: TelusDigitalLogo
  },
  ANTHROPOLOGIE: {
    id: "anthropologie",
    width: 140,
    height: 32,
    icon: AnthropologieLogo
  },
  SHOPIFY: {
    id: "shopify",
    width: 110,
    height: 32,
    icon: ShopifyLogo
  },
  HUBSPOT: {
    id: "hubspot",
    width: 97,
    height: 33,
    icon: HubspotLogo
  },
  GITHUB: {
    id: "github",
    width: 119,
    height: 32,
    icon: GithubLogo
  },
  SANOFI: {
    id: "sanofi",
    width: 122,
    height: 32,
    icon: SanofiLogo
  },
  CRAFTJACK: {
    id: "craftjack",
    width: 113,
    height: 33,
    icon: CraftJackLogo
  },
  REUTERS: {
    id: "reuters",
    width: 141,
    height: 32,
    icon: ReutersLogo
  },
  TERADATA: {
    id: "teradata",
    width: 153,
    height: 30,
    icon: TeradataLogo
  },
  CAMPING_WORLD: {
    id: "camping-world",
    width: 203,
    height: 32,
    icon: CampingWorldHomeLogo
  },
  CROSS_FIT: {
    id: "cross-fit",
    width: 100,
    height: 32,
    icon: CrossFitLogo
  },
  FRAME_IO: {
    id: "frame-io",
    width: 129,
    height: 33,
    icon: FrameIoLogo
  },
  ANGI: {
    id: "angi",
    width: 53,
    height: 32,
    icon: AngiLogo
  },
  AUTODESK: {
    id: "autodesk",
    width: 312,
    height: 32,
    icon: AutodeskLogo
  },
  AVANT: {
    id: "avant",
    width: 230,
    height: 32,
    icon: AvantLogo
  },
  CRUNCHY_ROLL: {
    id: "crunchy-roll",
    width: 169,
    height: 32,
    icon: CrunchyRollLogo
  },
  CSAA: {
    id: "csaa-logo",
    width: 171,
    height: 32,
    icon: CsaaLogo
  },
  FRASERS_GROUP: {
    id: "frasers-group",
    width: 253,
    height: 32,
    icon: FrasersGroupLogo
  },
  IMAX: {
    id: "imax",
    width: 169,
    height: 32,
    icon: ImaxLogo
  },
  MADEIRA_MADEIRA: {
    id: "madeira-madeira",
    width: 228,
    height: 32,
    icon: MadeiraMadeiraLogo
  },
  BRIGHTLINE: {
    id: "brightline",
    width: 131,
    height: 32,
    icon: BrightlineLogo
  },
  HATCH: {
    id: "hatch",
    width: 159,
    height: 32,
    icon: HatchLogo
  },
  LEMONADE: {
    id: "lemonade",
    width: 141,
    height: 32,
    icon: LemonadeLogo
  },
  OUTDOORSY: {
    id: "outdoorsy",
    width: 142,
    height: 32,
    icon: OutdoorsyLogo
  },
  ROCKET_MONEY: {
    id: "rocket-money",
    width: 144,
    height: 32,
    icon: RocketMoneyLogo
  },
  SWOOP: {
    id: "swoop",
    width: 93,
    height: 32,
    icon: SwoopLogo
  },
  TALK360: {
    id: "talk360",
    width: 170,
    height: 32,
    icon: Talk360Logo
  },
  TAWKIFY: {
    id: "tawkify",
    width: 129,
    height: 32,
    icon: TawkifyLogo
  },
  ZOLA: {
    id: "zola",
    width: 209,
    height: 32,
    icon: ZolaLogo
  },
  PAGER_DUTY: {
    id: "pager-duty",
    width: 118,
    height: 32,
    icon: PagerDutyLogo
  },
  MIND_BODY_GREEN: {
    id: "pager-duty",
    width: 187,
    height: 32,
    icon: MindbodygreenLogo
  },
  BABYLIST: {
    id: "babylist",
    width: 146,
    height: 32,
    icon: BabylistLogo
  },
  FIDELITY: {
    id: "fidelity",
    width: 119,
    height: 32,
    icon: FidelityLogo
  },
  GOOGLE_CLOUD: {
    id: "google-cloud",
    width: 185,
    height: 32,
    icon: GoogleCloudLogo
  },
  ZENJOB: {
    id: "zenjob",
    width: 171,
    height: 32,
    icon: ZenjobLogo
  },
  TWILIO: {
    id: "twilio",
    width: 104,
    height: 32,
    icon: TwilioLogo
  },
  TWILIO_SEGMENT: {
    id: "twilio-segment",
    width: 116,
    height: 32,
    icon: TwilioSegmentLogo
  },
  TREDENCE: {
    id: "tredence",
    width: 152,
    height: 32,
    icon: TredenceLogo
  },
  PEPPER_STONE: {
    id: "pepper-stone",
    width: 163,
    height: 32,
    icon: PepperStoneLogo
  }
};